import { get } from "lodash";
import { ImportPasserelleService } from "../../../sales/edit/add-item/import-passerelle.service";
import { thor } from "../../../typings/thor";
import { MAX_ONLINE_ITEMS } from "../../../thor.const";

export class ImportOnlinePasserelleService extends ImportPasserelleService {
    public static $inject: string[] = [
        "$log",
        "$q",
        "$rootScope",
        "$translate",
        "categoryService",
        "configService",
        "itemService",
        "mediaService",
        "mrSuricateService",
        "sitesService",
        "uploadService",
        "utilsService",
        "imageService"
    ];

    constructor(
        $log,
        $q,
        $rootScope: ng.IRootScopeService,
        $translate,
        categoryService,
        configService,
        itemService,
        mediaService,
        mrSuricate,
        _sitesService,
        uploadService,
        utilsService,
        imageService
    ) {
        super(
            $log,
            $q,
            $rootScope,
            $translate,
            categoryService,
            configService,
            itemService,
            mediaService,
            mrSuricate,
            _sitesService,
            uploadService,
            utilsService,
            imageService
        );

        this.maxItemsNbr = MAX_ONLINE_ITEMS;
    }

    protected createItem(itemData) {
        return this._createItem(itemData);
    }

    protected updateItem(item, itemData) {
        const patchedData: thor.ItemPatch = {};

        if (item.category.id !== itemData.item.category_id) {
            patchedData.category_id = itemData.item.category_id;
        }

        if (item.description !== itemData.item.description) {
            patchedData.description = itemData.item.description;

            if (!patchedData.description) {
                return this.$q.reject({
                    errorMessage: this.$t("mise_a_jour_impossible_le_descriptif_du_lot_est_manquant")
                });
            }
        }

        if (item.internal_reference !== itemData.item.internal_reference) {
            patchedData.internal_reference = itemData.item.internal_reference;
        }

        if (item.highlight !== itemData.item.highlight) {
            patchedData.highlight = itemData.item.highlight;
        }

        if (item.type !== itemData.item.type) {
            patchedData.type = itemData.item.type;
        }

        if (!angular.equals(item.meta, itemData.item.meta)) {
            patchedData.meta = itemData.item.meta;
        }

        if (!angular.equals(item.pricing, itemData.item.pricing)) {
            patchedData.pricing = itemData.item.pricing;
        }

        if (!angular.equals(item.features, itemData.item.features)) {
            patchedData.features = itemData.item.features;
        }

        if (item.states.suppressed === true || item.states.hidden === true) {
            patchedData.states = {
                suppressed: false,
                hidden: false
            };
        }

        if (angular.equals(patchedData, {}) || this.skipItemPublished(item)) {
            this.$log.info(`No changes ${this.addNewItemsOnly ? "allowed" : "detected"} for item: ${itemData.item.external_reference}`);
            this.summary.items.notModified++;
            return this.$q.resolve(item);
        }

        return this._updateItem(item, patchedData);
    }

    protected handleCreateErrors(error, itemData) {
        const lotNumber = get(itemData, "item.meta.order_number.primary");
        const lotId = get(itemData, "item.external_reference");
        const errorMessage = `${
            lotNumber ? this.$t("lot_n", { NUMBER: lotNumber }) : this.$t("identifiant_n", [lotId])
        } : ${get(error, "errorMessage") || this.$t("erreur_lors_de_la_mise_a_jour_du_lot")}`;

        this.notify("incrementGauge", { gauge: "items", counter: "error" });
        this.notify("incrementGauge", { gauge: "medias", counter: "error", increment: itemData.images.length });
        this.$log.error("Error while creating/updating item : ", errorMessage);
        this.summary.errors.push({
            message: errorMessage
        });
        return this.$q.reject(error);
    }

    private _checkValidity(itemData, patchedData) {
        const estimateMin = get(patchedData, "pricing.estimates.min") || get(itemData, "pricing.estimates.min");
        const estimateMax = get(patchedData, "pricing.estimates.max") || get(itemData, "pricing.estimates.max");
        const reservePrice = get(patchedData, "pricing.reserve_price") || get(itemData, "pricing.reserve_price", null);
        const startingPrice = get(patchedData, "pricing.starting_price") || get(itemData, "pricing.starting_price", 0);

        if (estimateMax && !estimateMin) {
            return { errorMessage: this.$t("mise_a_jour_impossible_l_estimation_basse_est_manquante") };
        } else if (estimateMax && estimateMin && estimateMin >= estimateMax) {
            return {
                errorMessage: this.$t(
                    "mise_a_jour_impossible_l_estimation_basse_doit_etre_inferieure_a_l_estimation_haute"
                )
            };
        } else if (estimateMin && reservePrice > estimateMin) {
            return {
                errorMessage: this.$t("mise_a_jour_impossible_le_prix_de_reserve_est_superieur_a_l_estimation_basse")
            };
        } else if (reservePrice && reservePrice < startingPrice) {
            return {
                errorMessage: this.$t("mise_a_jour_impossible_le_prix_de_reserve_est_inferieur_a_la_mise_a_prix")
            };
        }
    }

    private _updateItem(item, patchedData) {
        const error = this._checkValidity(item, patchedData);
        if (error) {
            return this.$q.reject(error);
        }

        return this.itemService.update(item.id, patchedData)
            .then(updatedItem => {
                this.summary.items.updated++;
                return this.$q.resolve(updatedItem);
            });
    }

    private _createItem(itemData) {
        const validityError = this._checkValidity(itemData.item, {});
        if (validityError) {
            return this.$q.reject(validityError);
        }

        if (!itemData.item.description) {
            return this.$q.reject({
                errorMessage: this.$t("mise_a_jour_impossible_le_descriptif_du_lot_est_manquant")
            });
        }

        return this.sale.createItem(itemData.item)
            .then(item => {
                this.summary.items.created++;
                return this.$q.resolve(item);
            }).catch(error => {
                this.$log.error("Error while creating item", error);
                return this.$q.reject(error);
            });
    }
}
